export const blockIconsMapsDirectionsBus = (
	<span className='material-symbols-outlined'>directions_bus</span>
);
